module.exports = __webpack_public_path__ + "img/c7ef85b.png";